import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { DiscoveryInfo, DiscoveryResult } from '../gateway.model';
import { GateWayDiscoveryActionTypes, GateWayDiscoveryActions } from '../actions/gateway-discovery.actions';

export interface GateWayDiscoveryInfoListState {
  Loaded: boolean;
  Loading: boolean;
  entities: DiscoveryInfo[];
}

export const initialDiscoveryInfoListState: GateWayDiscoveryInfoListState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export interface GateWayDiscoveryInfoState {
  Loaded: boolean;
  Loading: boolean;
  entities: DiscoveryInfo;
}

export const initialDiscoveryInfoState: GateWayDiscoveryInfoState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export interface GateWayExecuteDiscoveryState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialExecuteDiscoveryState: GateWayExecuteDiscoveryState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export interface GateWayExecuteDiscoveryListState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialExecuteDiscoveryListState: GateWayExecuteDiscoveryListState = {
  Loaded: false,
  Loading: false,
  entities: null
};
export interface GateWayDiscoveryResultListState {
  Loaded: boolean;
  Loading: boolean;
  entities: DiscoveryResult[];
}

export const initialDiscoveryResultListState: GateWayDiscoveryResultListState = {
  Loaded: false,
  Loading: false,
  entities: null
};
export interface GateWayDiscoveryExecutingResultForOneTimeState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialDiscoveryExecutingResultForOneTimeState: GateWayDiscoveryExecutingResultForOneTimeState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export function discoveryInfoListReducer(state = initialDiscoveryInfoListState, action: GateWayDiscoveryActions): GateWayDiscoveryInfoListState {
  switch (action.type) {
    case GateWayDiscoveryActionTypes.ReadDiscoveryInfoList:
      return {...state, Loaded: false, Loading: true};

    case GateWayDiscoveryActionTypes.UpsertDiscoveryInfoList:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case GateWayDiscoveryActionTypes.ReadDiscoveryInfoListFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default:
      return state;
  }
}

export function discoveryInfoReducer(state = initialDiscoveryInfoState, action: GateWayDiscoveryActions): GateWayDiscoveryInfoState {
  switch (action.type) {
    case GateWayDiscoveryActionTypes.ReadDiscoveryInfo:
      return {...state, Loaded: false, Loading: true};

    case GateWayDiscoveryActionTypes.UpsertDiscoveryInfo:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case GateWayDiscoveryActionTypes.ReadDiscoveryInfoFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default:
      return state;
  }
}

export function executeDiscoveryReducer(state = initialExecuteDiscoveryState, action: GateWayDiscoveryActions): GateWayExecuteDiscoveryState {
  switch (action.type) {
    case GateWayDiscoveryActionTypes.ExecuteDiscovery:
      return {...state, Loaded: false, Loading: true};

    case GateWayDiscoveryActionTypes.ExecuteDiscoverySuccess:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case GateWayDiscoveryActionTypes.ExecuteDiscoveryFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default:
      return state;
  }
}

export function executeDiscoveryListReducer(state = initialExecuteDiscoveryListState, action: GateWayDiscoveryActions): GateWayExecuteDiscoveryListState {
  switch (action.type) {
    case GateWayDiscoveryActionTypes.ExecuteDiscoveryList:
      return {...state, Loaded: false, Loading: true};

    case GateWayDiscoveryActionTypes.ExecuteDiscoveryListSuccess:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case GateWayDiscoveryActionTypes.ExecuteDiscoveryListFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default:
      return state;
  }
}

export function discoveryResultListReducer(state = initialDiscoveryResultListState, action: GateWayDiscoveryActions): GateWayDiscoveryResultListState {
  switch (action.type) {
    case GateWayDiscoveryActionTypes.ReadDiscoveryResultList:
      return {...state, Loaded: false, Loading: true};

    case GateWayDiscoveryActionTypes.UpsertDiscoveryResultList:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case GateWayDiscoveryActionTypes.ReadDiscoveryResultListFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default:
      return state;
  }
}

export function discoveryExecutingResultForOneTimeReducer(state = initialDiscoveryExecutingResultForOneTimeState, action: GateWayDiscoveryActions): GateWayDiscoveryExecutingResultForOneTimeState {
  switch (action.type) {
    case GateWayDiscoveryActionTypes.ReadDiscoveryExecutingResultForOneTime:
      return {...state, Loaded: false, Loading: true};

    case GateWayDiscoveryActionTypes.ReadDiscoveryExecutingResultForOneTimeSuccess:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case GateWayDiscoveryActionTypes.ReadDiscoveryExecutingResultForOneTimeFail: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    default:
      return state;
  }
}

export const getGateWayDiscoveryInfoListState = (state: GateWayDiscoveryInfoListState) => state;
export const getGateWayDiscoveryInfoState = (state: GateWayDiscoveryInfoState) => state;
export const getGateWayExecuteDiscoveryState = (state: GateWayExecuteDiscoveryState) => state;
export const getGateWayExecuteDiscoveryListState = (state: GateWayExecuteDiscoveryListState) => state;
export const getGateWayDiscoveryResultListState = (state: GateWayDiscoveryResultListState) => state;
export const getGateWayDiscoveryExecutingResultForOneTimeState = (state: GateWayDiscoveryExecutingResultForOneTimeState) => state;
